import { useState } from "react";
import { API_BASE } from "../api/client";

/** Site icon served same-origin by the API (fetched + cached server-side). Falls back to a
 *  letter tile when the domain has no usable icon. */
export function Favicon({ domain }: { domain: string }) {
  const [failed, setFailed] = useState(false);
  if (failed || !domain) {
    return (
      <span className="favicon fb" aria-hidden="true">
        {(domain[0] ?? "?").toUpperCase()}
      </span>
    );
  }
  return (
    <img
      className="favicon"
      src={`${API_BASE}/icons/${encodeURIComponent(domain)}`}
      alt=""
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
